import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Grid, Typography } from '@mui/material';
import Dashboard from '../../../compounds/Dashboard/Dashboard';
import Header from '../../../compounds/Common/Header';
import StyledTable from '../../../atoms/StyledTable/StyledTable';
import backInTimeInfo from './constants';

const PAGE_TITLE = "NCAA Women's Basketball Data Coverage";
const PAGE_SUBTITLE = "All stats are complete back to 2009-10, unless otherwise noted as going further back.";

const headers = [
  'Category',
  'Game Scores',
  'Player & Team Game Stats',
  'Notes',
];

const rowMap = {
  'Category': 'categoryName',
  'Game Scores': 'gameScores',
  'Player & Team Game Stats': 'playerAndTeamStats',
  'Notes': 'notes',
}

export default function NcaaWbbTeamDataInfoPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Dashboard>
      <Container sx={{ py: 2 }} maxWidth="xl">
        <Grid
          container
          direction="column"
          spacing={2}
          alignItems='start'
        >
          <Grid item>
            <Button
              onClick={handleBack}
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: (theme: any) => theme.palette.custom.mediumDarkGrey,
              }}
            >
              {'<'} Back
            </Button>
          </Grid>
          <Grid item>
            <Header title={PAGE_TITLE} subtitle={PAGE_SUBTITLE} />
          </Grid>
          <Grid item width='80%'>
            
            <StyledTable
              uniqueRowKey='No'
              headers={headers}
              data={backInTimeInfo}
              dataMap={rowMap}
            />
          </Grid>
          <Grid item width='80%'>
            <Typography sx={{ fontSize: '14px', fontStyle: 'italic' }}>
              * = Complete Tournament History
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Dashboard>
  );
};
